export const checkInvoiceType = (
  type: { value?: string } | string | null | undefined,
) => {
  let invoiceType;
  const value = typeof type === "string" ? type : type?.value;

  if (value === "purchase_order") {
    invoiceType = "invoices";
  } else if (value === "delivery_form") {
    invoiceType = "delivery";
  } else if (value === "sale_order") {
    invoiceType = "sale_order";
  } else if (value === "budget") {
    invoiceType = "budget";
  } else if (value === "return") {
    invoiceType = "return";
  } else if (value === "receipt") {
    invoiceType = "receipt";
  } else if (value === "payment_in_advance") {
    invoiceType = "payment_in_advance";
  }
  return invoiceType;
};

export const checkInvoiceTypeValue = (type: string | null | undefined) => {
  let invoiceType;

  if (type === "purchase_order") {
    invoiceType = "invoices";
  } else if (type === "delivery_form") {
    invoiceType = "delivery";
  } else if (type === "sale_order") {
    invoiceType = "sale_order";
  } else if (type === "budget") {
    invoiceType = "budget";
  } else if (type === "return") {
    invoiceType = "return";
  } else if (type === "receipt") {
    invoiceType = "receipt";
  } else if (type === "payment_in_advance") {
    invoiceType = "payment_in_advance";
  }
  return invoiceType;
};

export const checkInvoiceTypeGoBack = (type: { value?: string } | string | null | undefined) => {
  let invoiceType;
  const value = typeof type === "object" && type !== null ? type.value : undefined;

  if (value === "purchase_order") {
    invoiceType = "invoices";
  } else if (value === "delivery_form") {
    invoiceType = "delivery";
  } else if (value === "sale_order") {
    invoiceType = "sale_order";
  } else if (type === "return") {
    invoiceType = "return";
  } else if (type === "receipt") {
    invoiceType = "receipt";
  } else if (value === "payment_in_advance") {
    invoiceType = "payment_in_advance";
  }
  return invoiceType;
};
